import VehicleOwnerInfoDetailModal from './vehicle-owner-info-detail-modal.vue'
export default VehicleOwnerInfoDetailModal
